export default __webpack_public_path__ + "static/media/save-filled.0d0d7809.svg";